
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^[18qv]$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
